/**
 * Neu laden, wenn man in den Tab zurueckkommt.
 *
 * WARUM STATT „AKTUALISIEREN": Laeufe und Personas entstehen in Claude, nicht
 * hier. Der typische Weg ist: in Claude pruefen, dann hierher wechseln. Die
 * Seite lud dabei nicht neu, und der Knopf „Aktualisieren" war die einzige
 * Bruecke; wer ihn nicht bemerkte, sah einen alten Stand. Jetzt laedt die
 * Seite, sobald der Tab wieder sichtbar wird, hoechstens alle 30 Sekunden.
 * Bei einem Fehler steht ein Knopf im Fehlerkasten.
 */
import { useEffect, useRef } from 'react';

export const MIN_ABSTAND_MS = 30_000;

/** Pure Regel, fuer den Test: sichtbar geworden und lange genug her. */
export function sollNeuLaden(sichtbar: boolean, zuletzt: number, jetzt: number, abstand = MIN_ABSTAND_MS): boolean {
  return sichtbar && jetzt - zuletzt >= abstand;
}

export function useNeuLadenBeimZurueckkehren(laden: () => void) {
  const zuletzt = useRef(Date.now());
  const aktuell = useRef(laden);
  aktuell.current = laden;
  useEffect(() => {
    const pruefen = () => {
      const jetzt = Date.now();
      if (!sollNeuLaden(document.visibilityState === 'visible', zuletzt.current, jetzt)) return;
      zuletzt.current = jetzt;
      aktuell.current();
    };
    document.addEventListener('visibilitychange', pruefen);
    window.addEventListener('focus', pruefen);
    return () => {
      document.removeEventListener('visibilitychange', pruefen);
      window.removeEventListener('focus', pruefen);
    };
  }, []);
}
